import richText from "utilities/richText"
import ListItem from "components/ListItem"
import ImageHeading from "components/ImageHeading"
import DynamicComponent from ".."

export default function ListAndContent({ blok }) {
  return (
    <div className="w-full py-8 lg:pt-20 lg:pb-24">
      <div className="container-inset px-6 flex lg:justify-center">
        <div className="mx-auto lg:text-center max-w-2xl 2xl:max-w-4xl lg:justify-center text-white">
          <ImageHeading
            centered
            className="lg:justify-center"
            headingImage={blok.heading_image}
            fallback={blok.heading}
          />
          <div className="prose text-white">{richText(blok.content)}</div>
        </div>
      </div>

      {blok.list_items && (
        <div className="flex justify-center w-full">
          <ul className="container-inset px-6 grid lg:grid-cols-2 gap-12 pt-12">
            {blok.list_items.map((item) => {
              return <ListItem key={`list_item_${blok._uid}_${item._uid}`} item={item} />
            })}
          </ul>
        </div>
      )}

      {blok.blocks && (
        <div className="flex justify-center w-full">
          <div className="px-6 container-inset pt-12">
            {blok.blocks.map((blok) => {
              return <DynamicComponent blok={blok} key={blok._uid} />
            })}
          </div>
        </div>
      )}
    </div>
  )
}
